import React from "react";
import Routes from "./Routes/index";

// Import Scss
import './assets/scss/theme.scss';

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Firebase
// Import Firebase Configuration file
import { initFirebaseBackend } from "./helpers/firebase_helper"

// Activating fake backend
// fakeBackend();

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUKa1iHfZAdAjR8bZJhjTzHbnYWK2wRkI",
  authDomain: "fish-trak-app.firebaseapp.com",
  databaseURL: "https://fish-trak-app-default-rtdb.firebaseio.com",
  projectId: "fish-trak-app",
  storageBucket: "fish-trak-app.appspot.com",
  messagingSenderId: "109814780966",
  appId: "1:109814780966:web:be964b1e98a705e6a7c2e7",
  measurementId: "G-R2XPRQWKWP"
};

// init firebase backend
initFirebaseBackend(firebaseConfig)


function App() {
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
}

export default App;
